import type { GiantId } from '../../../../domain/ids/ids';
import { LEVEL_ART_VIEWBOX_WIDTH } from '../../../../domain/level/layoutViewBox';
import drakochiBg0 from '../../levels/drakochi/background/t0.png';
import drakochiBg1 from '../../levels/drakochi/background/t1.png';
import drakochiBg2 from '../../levels/drakochi/background/t2.png';
import drakochiBg3 from '../../levels/drakochi/background/t3.png';
import duckBg0 from '../../levels/duck/background/t0.png';
import duckBg1 from '../../levels/duck/background/t1.png';
import duckBg2 from '../../levels/duck/background/t2.png';
import duckBg3 from '../../levels/duck/background/t3.png';
import factorBg0 from '../../levels/factor/background/t0.png';
import factorBg1 from '../../levels/factor/background/t1.png';
import factorBg2 from '../../levels/factor/background/t2.png';
import factorBg3 from '../../levels/factor/background/t3.png';
import monaBg0 from '../../levels/mona/background/t0.png';
import monaBg1 from '../../levels/mona/background/t1.png';
import monaBg2 from '../../levels/mona/background/t2.png';
import monaBg3 from '../../levels/mona/background/t3.png';
import muBg0 from '../../levels/mu/background/t0.png';
import muBg1 from '../../levels/mu/background/t1.png';
import muBg2 from '../../levels/mu/background/t2.png';
import muBg3 from '../../levels/mu/background/t3.png';
import rozaBg0 from '../../levels/roza/background/t0.png';
import rozaBg1 from '../../levels/roza/background/t1.png';
import rozaBg2 from '../../levels/roza/background/t2.png';
import rozaBg3 from '../../levels/roza/background/t3.png';
import serjBg0 from '../../levels/serj/background/t0.png';
import serjBg1 from '../../levels/serj/background/t1.png';
import serjBg2 from '../../levels/serj/background/t2.png';
import serjBg3 from '../../levels/serj/background/t3.png';
import solBg0 from '../../levels/sol/background/t0.png';
import solBg1 from '../../levels/sol/background/t1.png';
import solBg2 from '../../levels/sol/background/t2.png';
import solBg3 from '../../levels/sol/background/t3.png';
import svamiBg0 from '../../levels/svami/background/t0.png';
import svamiBg1 from '../../levels/svami/background/t1.png';
import svamiBg2 from '../../levels/svami/background/t2.png';
import svamiBg3 from '../../levels/svami/background/t3.png';
import willyBg0 from '../../levels/willy/background/t0.png';
import willyBg1 from '../../levels/willy/background/t1.png';
import willyBg2 from '../../levels/willy/background/t2.png';
import willyBg3 from '../../levels/willy/background/t3.png';
import yettiBg0 from '../../levels/yetti/background/t0.png';
import yettiBg1 from '../../levels/yetti/background/t1.png';
import yettiBg2 from '../../levels/yetti/background/t2.png';
import yettiBg3 from '../../levels/yetti/background/t3.png';
import duckFg0 from '../../levels/duck/foreground/t0.png';
import duckFg1 from '../../levels/duck/foreground/t1.png';
import duckFg2 from '../../levels/duck/foreground/t2.png';
import duckFg3 from '../../levels/duck/foreground/t3.png';
import factorFg0 from '../../levels/factor/foreground/t0.png';
import factorFg1 from '../../levels/factor/foreground/t1.png';
import factorFg2 from '../../levels/factor/foreground/t2.png';
import factorFg3 from '../../levels/factor/foreground/t3.png';
import monaFg0 from '../../levels/mona/foreground/t0.png';
import monaFg1 from '../../levels/mona/foreground/t1.png';
import monaFg2 from '../../levels/mona/foreground/t2.png';
import monaFg3 from '../../levels/mona/foreground/t3.png';
import muFg0 from '../../levels/mu/foreground/t0.png';
import muFg1 from '../../levels/mu/foreground/t1.png';
import muFg2 from '../../levels/mu/foreground/t2.png';
import muFg3 from '../../levels/mu/foreground/t3.png';
import rozaFg0 from '../../levels/roza/foreground/t0.png';
import rozaFg1 from '../../levels/roza/foreground/t1.png';
import rozaFg2 from '../../levels/roza/foreground/t2.png';
import rozaFg3 from '../../levels/roza/foreground/t3.png';
import serjFg0 from '../../levels/serj/foreground/t0.png';
import serjFg1 from '../../levels/serj/foreground/t1.png';
import serjFg2 from '../../levels/serj/foreground/t2.png';
import serjFg3 from '../../levels/serj/foreground/t3.png';
import svamiFg0 from '../../levels/svami/foreground/t0.png';
import svamiFg1 from '../../levels/svami/foreground/t1.png';
import svamiFg2 from '../../levels/svami/foreground/t2.png';
import svamiFg3 from '../../levels/svami/foreground/t3.png';
import willyFg0 from '../../levels/willy/foreground/t0.png';
import willyFg1 from '../../levels/willy/foreground/t1.png';
import willyFg2 from '../../levels/willy/foreground/t2.png';
import willyFg3 from '../../levels/willy/foreground/t3.png';
import yettiFg0 from '../../levels/yetti/foreground/t0.png';
import yettiFg1 from '../../levels/yetti/foreground/t1.png';
import yettiFg2 from '../../levels/yetti/foreground/t2.png';
import yettiFg3 from '../../levels/yetti/foreground/t3.png';
import drakochiGiant from '../../levels/drakochi/drakochi.png';
import duckGiant from '../../levels/duck/duck.png';
import factorGiant from '../../levels/factor/factor.png';
import monaGiant from '../../levels/mona/mona.png';
import muGiant from '../../levels/mu/mu.png';
import rozaGiant from '../../levels/roza/roza.png';
import serjGiant from '../../levels/serj/serj.png';
import solGiant from '../../levels/sol/sol.png';
import svamiGiant from '../../levels/svami/svami.png';
import willyGiant from '../../levels/willy/willy.png';
import yettiGiant from '../../levels/yetti/yetti.png';
import drakochiStatic from '../../levels/drakochi/obstacles/static.png';
import duckStatic from '../../levels/duck/obstacles/static.png';
import factorStatic from '../../levels/factor/obstacles/static.png';
import monaStatic from '../../levels/mona/obstacles/static.png';
import muStatic from '../../levels/mu/obstacles/static.png';
import rozaStatic from '../../levels/roza/obstacles/static.png';
import serjStatic from '../../levels/serj/obstacles/static.png';
import svamiStatic from '../../levels/svami/obstacles/static.png';
import staticObstacle from '../../levels/willy/obstacles/static.png';
import yettiStatic from '../../levels/yetti/obstacles/static.png';
import willyLoupeOverlay from '../../levels/willy/obstacles/m.png';
import duckBall from '../../levels/duck/obstacles/ball.png';
import muMeteor1 from '../../levels/mu/obstacles/m_1.png';
import muMeteor2 from '../../levels/mu/obstacles/m_2.png';
import muMeteor3 from '../../levels/mu/obstacles/m_3.png';
import muMeteor4 from '../../levels/mu/obstacles/m_4.png';
import yettiUp from '../../levels/yetti/obstacles/up.png';
import yettiBottom from '../../levels/yetti/obstacles/bottom.png';
import factor1 from '../../levels/factor/obstacles/1.png';
import factor2 from '../../levels/factor/obstacles/2.png';
import monaTentacle1 from '../../levels/mona/obstacles/m-1.svg';
import monaTentacle2 from '../../levels/mona/obstacles/m-2.svg';
import monaTentacle3 from '../../levels/mona/obstacles/m-3.svg';
import monaMoving from '../../levels/mona/obstacles/moving.png';
import svamiM from '../../levels/svami/obstacles/m.png';
import solStatic from '../../levels/sol/obstacles/static.png';
import solMod from '../../levels/sol/obstacles/mod.png';
import drakochiLava from '../../levels/drakochi/obstacles/lava.png';
import collectibleIcon from '../../components/atomic/icons/collectible/collectible.png';
import shieldBoosterIcon from '../../components/atomic/icons/boosters/shield_booster.png';
import speedBoosterIcon from '../../components/atomic/icons/boosters/speed_booster.png';
import itemShine from '../../components/atomic/effects/item_shine/item_shine.png';
import type {
  RunnerDecorSpriteKey,
  RunnerDuckObstacleSpriteKey,
  RunnerMeteorSpriteKey,
  RunnerMonaObstacleSpriteKey,
  RunnerObstacleSpriteKey,
} from '../../../../domain/runner/runnerTypes';
import { LEVEL_FOREGROUND_ENABLED } from './gameplayConstants';

export const LEVEL_PANORAMA_TILE_COUNT = 4;

export const LEVEL_PANORAMA_TILE_ART_WIDTH =
  LEVEL_ART_VIEWBOX_WIDTH / LEVEL_PANORAMA_TILE_COUNT;

export type PanoramaTiles = readonly [string, string, string, string];

export type LevelVisualAssets = {
  skyBackground: string;
  backgroundTiles: PanoramaTiles;
  foregroundTiles: PanoramaTiles | null;
  giantUrl: string;
};

/** CSS sky fill under transparent background.png (colors from .dev/skies). */
const LEVEL_SKY_BACKGROUNDS: Record<GiantId, string> = {
  duck: '#4CC3C7',
  factor: '#C5E1AE',
  drakochi: 'linear-gradient(180deg, #E6494C 0%, #EE704F 50%, #F79651 100%)',
  mona: 'linear-gradient(180deg, #E3B1CB 0%, #F0D5C1 50%, #F5E4BE 100%)',
  mu: 'linear-gradient(180deg, #1A121A 0%, #3E202D 50%, #1B121B 100%)',
  roza: 'linear-gradient(180deg, #57337B 0%, #302562 55%)',
  serj: 'linear-gradient(180deg, #8B6ACB 0%, #7B99DA 50%, #73B2E1 100%)',
  sol: 'linear-gradient(180deg, #95A4D4 0%, #CAC7C5 50%, #FCE7B7 100%)',
  svami: 'linear-gradient(180deg, #A0D3E9 0%, #D4CCBF 50%, #E7C9AF 100%)',
  willy: 'linear-gradient(180deg, #A790C4 0%, #FBCDCB 20%, #FFF9C2 55%)',
  yetti: 'linear-gradient(180deg, #5DA9DD 0%, #538ECB 50%, #4B73B9 100%)',
};

const BACKGROUND_TILES: Record<GiantId, PanoramaTiles> = {
  drakochi: [drakochiBg0, drakochiBg1, drakochiBg2, drakochiBg3],
  duck: [duckBg0, duckBg1, duckBg2, duckBg3],
  factor: [factorBg0, factorBg1, factorBg2, factorBg3],
  mona: [monaBg0, monaBg1, monaBg2, monaBg3],
  mu: [muBg0, muBg1, muBg2, muBg3],
  roza: [rozaBg0, rozaBg1, rozaBg2, rozaBg3],
  serj: [serjBg0, serjBg1, serjBg2, serjBg3],
  sol: [solBg0, solBg1, solBg2, solBg3],
  svami: [svamiBg0, svamiBg1, svamiBg2, svamiBg3],
  willy: [willyBg0, willyBg1, willyBg2, willyBg3],
  yetti: [yettiBg0, yettiBg1, yettiBg2, yettiBg3],
};

const FOREGROUND_TILES: Record<GiantId, PanoramaTiles | null> = {
  drakochi: null,
  duck: [duckFg0, duckFg1, duckFg2, duckFg3],
  factor: [factorFg0, factorFg1, factorFg2, factorFg3],
  mona: [monaFg0, monaFg1, monaFg2, monaFg3],
  mu: [muFg0, muFg1, muFg2, muFg3],
  roza: [rozaFg0, rozaFg1, rozaFg2, rozaFg3],
  serj: [serjFg0, serjFg1, serjFg2, serjFg3],
  sol: null,
  svami: [svamiFg0, svamiFg1, svamiFg2, svamiFg3],
  willy: [willyFg0, willyFg1, willyFg2, willyFg3],
  yetti: [yettiFg0, yettiFg1, yettiFg2, yettiFg3],
};

const GIANTS: Record<GiantId, string> = {
  drakochi: drakochiGiant,
  duck: duckGiant,
  factor: factorGiant,
  mona: monaGiant,
  mu: muGiant,
  roza: rozaGiant,
  serj: serjGiant,
  sol: solGiant,
  svami: svamiGiant,
  willy: willyGiant,
  yetti: yettiGiant,
};

export function getLevelVisualAssets(giantId: GiantId): LevelVisualAssets {
  return {
    skyBackground: LEVEL_SKY_BACKGROUNDS[giantId],
    backgroundTiles: BACKGROUND_TILES[giantId],
    foregroundTiles: LEVEL_FOREGROUND_ENABLED
      ? FOREGROUND_TILES[giantId]
      : null,
    giantUrl: GIANTS[giantId],
  };
}

const STATIC_OBSTACLES: Record<GiantId, string> = {
  drakochi: drakochiStatic,
  duck: duckStatic,
  factor: factorStatic,
  mona: monaStatic,
  mu: muStatic,
  roza: rozaStatic,
  serj: serjStatic,
  sol: solStatic,
  svami: svamiStatic,
  willy: staticObstacle,
  yetti: yettiStatic,
};

export function getStaticObstacleUrl(giantId: GiantId): string {
  return STATIC_OBSTACLES[giantId];
}

export const LEVEL_COLLECTIBLE_ICON_URL = collectibleIcon;
export const LEVEL_SHIELD_BOOSTER_ICON_URL = shieldBoosterIcon;
export const LEVEL_SPEED_BOOSTER_ICON_URL = speedBoosterIcon;
export const LEVEL_ITEM_SHINE_URL = itemShine;

const DUCK_OBSTACLE_SPRITE_URLS: Record<RunnerDuckObstacleSpriteKey, string> = {
  duck_ball: duckBall,
};

const MONA_OVERLAY_ASSET_URLS = [
  monaTentacle1,
  monaTentacle2,
  monaTentacle3,
] as const;

const MONA_OBSTACLE_SPRITE_URLS: Record<RunnerMonaObstacleSpriteKey, string> = {
  mona_moving: monaMoving,
};

const WILLY_OVERLAY_ASSET_URLS = [willyLoupeOverlay] as const;

const SVAMI_OVERLAY_ASSET_URLS = [svamiM] as const;

const SOL_OVERLAY_ASSET_URLS = [solMod] as const;

const FACTOR_OVERLAY_ASSET_URLS = [factor1, factor2] as const;

const MU_OVERLAY_ASSET_URLS = [
  muMeteor1,
  muMeteor2,
  muMeteor3,
  muMeteor4,
] as const;

const YETTI_OVERLAY_ASSET_URLS = [yettiUp, yettiBottom] as const;

const DRAKOCHI_OVERLAY_ASSET_URLS = [drakochiLava] as const;

export function getObstacleSpriteUrl(spriteKey: RunnerObstacleSpriteKey): string {
  if (spriteKey in DUCK_OBSTACLE_SPRITE_URLS) {
    return DUCK_OBSTACLE_SPRITE_URLS[spriteKey as RunnerDuckObstacleSpriteKey];
  }
  if (spriteKey in MONA_OBSTACLE_SPRITE_URLS) {
    return MONA_OBSTACLE_SPRITE_URLS[spriteKey as RunnerMonaObstacleSpriteKey];
  }
  // Legacy meteor keys kept for type compatibility; unused in world after overlay migrate.
  const meteors: Record<RunnerMeteorSpriteKey, string> = {
    m_1: muMeteor1,
    m_2: muMeteor2,
    m_3: muMeteor3,
    m_4: muMeteor4,
  };
  return meteors[spriteKey as RunnerMeteorSpriteKey];
}

export function getDecorSpriteUrl(_spriteKey: RunnerDecorSpriteKey): string {
  return '';
}

/** Shared icons needed by any level (loaded with that giant, not at app start). */
export function getSharedLevelIconUrls(): string[] {
  return [
    LEVEL_COLLECTIBLE_ICON_URL,
    LEVEL_SHIELD_BOOSTER_ICON_URL,
    LEVEL_SPEED_BOOSTER_ICON_URL,
    LEVEL_ITEM_SHINE_URL,
  ];
}

function getGiantGameplaySpriteUrls(giantId: GiantId): string[] {
  switch (giantId) {
    case 'mu':
      return [...MU_OVERLAY_ASSET_URLS];
    case 'yetti':
      return [...YETTI_OVERLAY_ASSET_URLS];
    case 'willy':
      return [...WILLY_OVERLAY_ASSET_URLS];
    case 'duck':
      return [...Object.values(DUCK_OBSTACLE_SPRITE_URLS)];
    case 'factor':
      return [...FACTOR_OVERLAY_ASSET_URLS];
    case 'roza':
      return [];
    case 'mona':
      return [
        ...MONA_OVERLAY_ASSET_URLS,
        ...Object.values(MONA_OBSTACLE_SPRITE_URLS),
      ];
    case 'svami':
      return [...SVAMI_OVERLAY_ASSET_URLS];
    case 'serj':
      return [];
    case 'sol':
      return [...SOL_OVERLAY_ASSET_URLS];
    case 'drakochi':
      return [...DRAKOCHI_OVERLAY_ASSET_URLS];
    default:
      return [];
  }
}

/** Shared gameplay icons plus per-giant obstacle/decor sprites. */
export function getSharedLevelGameplayAssetUrls(): string[] {
  return [
    ...getSharedLevelIconUrls(),
    ...MU_OVERLAY_ASSET_URLS,
    ...YETTI_OVERLAY_ASSET_URLS,
    ...WILLY_OVERLAY_ASSET_URLS,
    ...Object.values(DUCK_OBSTACLE_SPRITE_URLS),
    ...FACTOR_OVERLAY_ASSET_URLS,
    ...MONA_OVERLAY_ASSET_URLS,
    ...Object.values(MONA_OBSTACLE_SPRITE_URLS),
    ...SVAMI_OVERLAY_ASSET_URLS,
    ...SOL_OVERLAY_ASSET_URLS,
    ...DRAKOCHI_OVERLAY_ASSET_URLS,
  ];
}

/** Background/foreground tiles/static/sprites for the given giants only, plus shared icons. */
export function getLevelVisualAssetUrlsForGiants(
  giantIds: readonly GiantId[],
): string[] {
  const urls: string[] = [];
  const seen = new Set<string>();
  const push = (url: string | null | undefined) => {
    if (url == null || url === '' || seen.has(url)) {
      return;
    }
    seen.add(url);
    urls.push(url);
  };
  for (const iconUrl of getSharedLevelIconUrls()) {
    push(iconUrl);
  }
  for (const giantId of giantIds) {
    const { backgroundTiles, foregroundTiles, giantUrl } =
      getLevelVisualAssets(giantId);
    for (const tile of backgroundTiles) {
      push(tile);
    }
    if (foregroundTiles != null) {
      for (const tile of foregroundTiles) {
        push(tile);
      }
    }
    push(giantUrl);
    push(getStaticObstacleUrl(giantId));
    for (const spriteUrl of getGiantGameplaySpriteUrls(giantId)) {
      push(spriteUrl);
    }
  }
  return urls;
}

export function getAllLevelVisualAssetUrls(): string[] {
  return [
    ...getSharedLevelGameplayAssetUrls(),
    ...getLevelVisualAssetUrlsForGiants(
      Object.keys(BACKGROUND_TILES) as GiantId[],
    ),
  ];
}
